export default __webpack_public_path__ + "static/media/model-3-mobile.e3cfa47a.jpeg";